import React from "react";
import { bool, node } from "prop-types";
import { Card } from "@mui/material";
import { cardHover } from "../component-styles";

const BaseCard = ({ cardGrows = false, allowHover = true, children }) => {
  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: theme.palette.secondary.light,
        ...(cardGrows && {
          display: "flex",
          flexGrow: 1,
          minHeight: "150px",
        }),
        ...(allowHover && cardHover(theme.palette)),
      })}
    >
      {children}
    </Card>
  );
};

BaseCard.propTypes = {
  cardGrows: bool,
  allowHover: bool,
  children: node.isRequired,
};

export default BaseCard;
